import * as Request                 from '../request'

/*
 * Makes a call to the blob store to upload the image pixels.
 * @sig uploadPixels :: (Image, String, String, JWT) -> ()
*/
const uploadPixels = async (image, contentType, entityType, accessToken) => {
    const url = `${entityType}.locuslabs.com`

    const message = `uploadPixels: your changes will NOT be saved\n`
        + `*\n`
        + `*     url: ${ url }\n`
        + `*`
    Request.banner(message)
    return Promise.resolve(image.id)
}


const getBlob = async (image, accessToken) => {
    Request.banner('getBlob: your changes will NOT be saved')
    return Promise.resolve('https://img.locuslabs.com/poi/IMG_20170118_143646.jpg')
}

const MockBlob = {
    uploadPixels,
    getBlob,
}

export { MockBlob }
